// extracted by mini-css-extract-plugin
export default {"FormCard":"Forms_FormCard__zonRq","googleLogin":"Forms_googleLogin__KfUFJ","form":"Forms_form__fAOuf","element":"Forms_element__wVMnZ"};